import { useEffect, useRef } from 'react';

export const TransparentInput = (props: any) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const baseStyle: any = {
        margin: '5px',
        padding: '10px',
        minWidth: '100%',
        border: 'none',
        backgroundColor: 'transparent',
        color: '#fff',
        fontFamily: 'inherit',
        fontSize: 'inherit',
    }

    if (props.width) {
        baseStyle.width = props.width;
    }

    useEffect(() => {
        if (props.multiline && textareaRef.current) {
            const textarea = textareaRef.current;
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    }, [props.value, props.multiline]);

    if (props.multiline) {
        const textareaStyle = {
            ...baseStyle,
            resize: 'none' as const,
            minHeight: '40px',
            overflow: 'hidden',
        };

        return (
            <textarea
                ref={textareaRef}
                title={props.tooltip || ""}
                placeholder={props.placeholder || ""}
                value={props.value || ""}
                style={textareaStyle}
                onChange={props.onChange}
                onBlur={props.onBlur}
                required={props.required}
            />
        );
    }

    return (
        <input
            title={props.tooltip || ""}
            placeholder={props.placeholder || ""}
            type="text"
            value={props.value || ""}
            style={baseStyle}
            onChange={props.onChange}
            onBlur={props.onBlur}
            required={props.required}
        />
    );
}
